"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@material-ui/core");
var _icons = require("@material-ui/icons");
var _styles = _interopRequireDefault(require("./styles"));
var _ChapterList = _interopRequireDefault(require("../ChapterList"));
var _HighlightsList = _interopRequireDefault(require("../HighlightsList"));
var _BookmarksList = _interopRequireDefault(require("../BookmarksList"));
var _HighlightList = require("../../contexts/HighlightList");
var _Trackings = _interopRequireDefault(require("../../services/Trackings"));
var _Auth = require("../../contexts/Auth");
var _PdfReader = _interopRequireDefault(require("../../services/PdfReader"));
var _Copy = require("../../constants/Copy");
var _CopyrightWarnDialog = _interopRequireDefault(require("../CopyrightWarnDialog"));
var _CopyTextDialog = _interopRequireDefault(require("../CopyTextDialog"));
var _CopyLimitDialog = _interopRequireDefault(require("../CopyLimitDialog"));
var _Copy2 = _interopRequireDefault(require("../../services/Copy"));
var _Copy3 = require("../../contexts/Copy");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function Drawer(props) {
  var {
    openDrawer,
    setOpenDrawer,
    chapters,
    pdf
  } = props;
  var {
    focus
  } = (0, _HighlightList.useHighlightList)();
  var {
    auth
  } = (0, _Auth.useAuth)();
  var trackService = (0, _Trackings.default)(auth);
  var [title, setTitle] = (0, _react.useState)(auth.bookTitle);
  var {
    uuid,
    bookTitle
  } = auth;
  var [limitDialog, setLimitDialog] = (0, _react.useState)(false);
  var [copyDialog, setCopyDialog] = (0, _react.useState)(false);
  var [copyrigthWarnDialog, setCopyrigthWarnDialog] = (0, _react.useState)(false);
  var [copyContent, setCopyContent] = (0, _react.useState)();
  var {
    copyValue,
    setCopyValue
  } = (0, _Copy3.useCopy)();
  (0, _react.useEffect)(() => {
    if (!pdf) return;
    _PdfReader.default.getBookTitle(pdf).then(title => title && setTitle(title));
  }, [pdf]);
  (0, _react.useEffect)(() => {
    if (focus) selectTab('tab-1');
  }, [focus]);
  var TABS = {
    'tab-0': /*#__PURE__*/_react.default.createElement(_ChapterList.default, {
      pdf: pdf,
      chapters: chapters
    }),
    'tab-1': /*#__PURE__*/_react.default.createElement(_HighlightsList.default, {
      pdf: pdf,
      setOpenDrawer: setOpenDrawer,
      handleCopyButtonClick: handleCopyButtonClick
    }),
    'tab-2': /*#__PURE__*/_react.default.createElement(_BookmarksList.default, {
      pdf: pdf
    })
  };
  var TAB = {
    CHAPTER: {
      label: 'Capítulos'
    },
    NOTE: {
      label: 'Notas',
      onClick: () => trackService.trackAccessHighlight({
        uuid,
        titleCover: bookTitle
      })
    },
    BOOKMARK: {
      label: 'Marcadores',
      onClick: () => trackService.trackAccessBookmark()
    }
  };
  var [hash, setHash] = (0, _react.useState)(global.location.hash);
  var [tabSelected, selectTab] = (0, _react.useState)('tab-0');
  var [onHashChangeCallback, setOnHashChangeCallback] = (0, _react.useState)();
  var HASH = 'menu';
  var classes = (0, _styles.default)();
  var handleTabChange = (_evt, newValue) => {
    selectTab(newValue);
    setOpenDrawer(true);
  };
  (0, _react.useEffect)(() => {
    function onHashChange() {
      if (onHashChangeCallback) {
        onHashChangeCallback();
        setOnHashChangeCallback();
      }
    }
    window.addEventListener('hashchange', onHashChange);
    return () => window.removeEventListener('hashchange', onHashChange);
  }, [onHashChangeCallback, setOnHashChangeCallback]);
  (0, _react.useEffect)(() => {
    function onBackNavigation() {
      if (hash.includes(HASH)) {
        setOpenDrawer(false);
      }
      setHash(global.location.hash);
    }
    window.addEventListener('hashchange', onBackNavigation);
    return () => window.removeEventListener('hashchange', onBackNavigation);
  }, [hash, setOpenDrawer]);
  (0, _react.useEffect)(() => {
    if (openDrawer) {
      global.location.hash = HASH;
    } else if (global.location.hash.includes(HASH)) {
      window.history.back();
    }
  }, [openDrawer]);
  var handleCloseDrawer = () => {
    setOpenDrawer(false);
  };
  function handleCopyButtonClick(_x) {
    return _handleCopyButtonClick.apply(this, arguments);
  }
  function _handleCopyButtonClick() {
    _handleCopyButtonClick = _asyncToGenerator(function* (highlight) {
      var {
        applicationToken,
        sessionToken,
        userId,
        uuid
      } = auth;
      setCopyContent(highlight);
      var copyrightWarn = yield _Copy2.default.getCopyrightStatus(applicationToken, sessionToken, userId, uuid);
      if (copyValue >= 100) {
        setOpenDrawer(false);
        setTimeout(() => {
          setLimitDialog(true);
        }, 200);
      } else if (copyrightWarn && copyValue < 100) {
        setOpenDrawer(false);
        setTimeout(() => {
          setCopyDialog(true);
        }, 200);
      } else if (!copyrightWarn && copyValue < 100) {
        setOpenDrawer(false);
        setTimeout(() => {
          setCopyrigthWarnDialog(true);
        }, 200);
      }
    });
    return _handleCopyButtonClick.apply(this, arguments);
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.Drawer, {
    className: classes.drawer,
    anchor: "left",
    open: openDrawer,
    classes: {
      paper: classes.drawerPaper
    },
    onClose: handleCloseDrawer
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.drawerHeader
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "body1",
    className: classes.title
  }, title), /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    onClick: handleCloseDrawer
  }, /*#__PURE__*/_react.default.createElement(_icons.Close, {
    classes: {
      root: classes.drawerClose
    }
  }))), /*#__PURE__*/_react.default.createElement(_core.Tabs, {
    value: tabSelected,
    onChange: handleTabChange,
    indicatorColor: "primary",
    textColor: "primary",
    variant: "fullWidth"
  }, Object.values(TAB).map((tab, index) => /*#__PURE__*/_react.default.createElement(_core.Tab, {
    label: tab.label,
    value: "tab-".concat(index),
    index: index,
    classes: {
      root: classes.tab
    },
    key: tab.label,
    onClick: () => tab.onClick && tab.onClick()
  }))), /*#__PURE__*/_react.default.createElement(_core.Divider, null), /*#__PURE__*/_react.default.createElement(_core.Paper, {
    classes: {
      root: classes.drawerContent
    },
    elevation: 0
  }, ['tab-0', 'tab-1', 'tab-2'].map(tabPanel => /*#__PURE__*/_react.default.createElement("div", {
    hidden: tabSelected !== tabPanel,
    key: tabPanel
  }, TABS[tabPanel])))), /*#__PURE__*/_react.default.createElement(_CopyrightWarnDialog.default, {
    pdf: pdf,
    copyContent: copyContent,
    setCopyContent: setCopyContent,
    copyDialog: copyDialog,
    setCopyDialog: setCopyDialog,
    copyrigthWarnDialog: copyrigthWarnDialog,
    setCopyrigthWarnDialog: setCopyrigthWarnDialog
  }), /*#__PURE__*/_react.default.createElement(_CopyTextDialog.default, {
    copyValue: copyValue,
    setCopyValue: setCopyValue,
    pdf: pdf,
    copyContent: copyContent,
    copyDialog: copyDialog,
    setCopyContent: setCopyContent,
    setCopyDialog: setCopyDialog,
    setCopyrigthWarnDialog: setCopyrigthWarnDialog,
    origin: _Copy.ORIGIN.HIGHLIGHT
  }), /*#__PURE__*/_react.default.createElement(_CopyLimitDialog.default, {
    limitDialog: limitDialog,
    setLimitDialog: setLimitDialog
  }));
}
Drawer.propTypes = {
  pdf: _propTypes.default.object,
  chapters: _propTypes.default.array,
  openDrawer: _propTypes.default.bool.isRequired,
  setOpenDrawer: _propTypes.default.func.isRequired
};
var _default = exports.default = Drawer;